import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", function() {
    const dismissButton = document.querySelector('.global-banner__dismiss');
    const banner = document.querySelector('.global-banner');

    // Check if the cookie exists
    if (Cookies.get('globalBannerDismissed')) {
        // If cookie exists, hide the banner
        banner.classList.add('hide');
    }

    if (dismissButton) {
        dismissButton.addEventListener('click', function() {
            // Set a cookie that expires in 30 days
            Cookies.set('globalBannerDismissed', 'true', { expires: 30 });

            // Hide the banner
            banner.classList.add('hide');
        });
    }
});
